import { Alert, Button } from '@mui/material';
import { isRateLimited } from '../../utils/rateLimit';

/** Shown when the dashboard figures fail to load (2026-11-03): the KPI
 * cards keep showing "—" (never a made-up zero), and this says why. */
export const DashboardLoadError = ({ error, onRetry }: { error: unknown; onRetry: () => void }) => (
  <Alert
    severity="warning"
    sx={{ mb: 2 }}
    data-testid="dashboard-load-error"
    action={
      <Button color="inherit" size="small" onClick={onRetry}>
        Retry
      </Button>
    }
  >
    {isRateLimited(error)
      ? 'The server is busy right now, so the dashboard figures could not be loaded. Please try again in a moment.'
      : 'The dashboard figures could not be loaded. Please try again.'}
  </Alert>
);
